/// <reference path="wtcp.util.js"/>
global.WtcpJs = global.WtcpJs || {};

var util = require('./wtcp.util.js');

(function(locatorModule) {

    function getNonce() {
        return Math.floor(Math.random() * 9999) + 1;
    }

    locatorModule.JXON = function(options) {
        if (!(this instanceof locatorModule.JXON))
            return new locatorModule.JXON(options);

        return this;
    };

    /*locatorModule.JXON.prototype = Object.create(locatorModule.WtcpBase.prototype);
    locatorModule.JXON.prototype.constructor = locatorModule.JXON;*/

    locatorModule.JXON.prototype.getJXONTree = function(oXMLParent) {
        oXMLParent.hasAttributes = oXMLParent.hasAttributes || function() { return false; };
        var vResult = /* put here the default value for empty nodes! */ true, nLength = 0, sCollectedTxt = "", oAttrib = null;
        if (oXMLParent.hasAttributes()) {
            vResult = {};
            for (nLength; nLength < oXMLParent.attributes.length; nLength++) {
                oAttrib = oXMLParent.attributes.item(nLength);
                vResult["@" + oAttrib.name.toLowerCase()] = this.parseText(oAttrib.value.trim());
            }
        }
        if (oXMLParent.hasChildNodes()) {
            for (var oNode, sProp, vContent, nItem = 0; nItem < oXMLParent.childNodes.length; nItem++) {
                oNode = oXMLParent.childNodes.item(nItem);
                if (oNode.nodeType === 4) {
                    sCollectedTxt += oNode.nodeValue;
                } /* nodeType is "CDATASection" (4) */
                else if (oNode.nodeType === 3) {
                    sCollectedTxt += oNode.nodeValue.trim();
                } /* nodeType is "Text" (3) */
                else if (oNode.nodeType === 1 && !oNode.prefix) { /* nodeType is "Element" (1) */
                    if (nLength === 0) {
                        vResult = {};
                    }
                    sProp = oNode.nodeName.toLowerCase();
                    vContent = this.getJXONTree(oNode);
                    if (vResult.hasOwnProperty(sProp)) {
                        if (vResult[sProp].constructor !== Array) {
                            vResult[sProp] = [vResult[sProp]];
                        }
                        vResult[sProp].push(vContent);
                    } else {
                        vResult[sProp] = vContent;
                        nLength++;
                    }
                }
            }
        }
        if (sCollectedTxt) {
            nLength > 0 ? vResult.keyValue = this.parseText(sCollectedTxt) : vResult = this.parseText(sCollectedTxt);
        }
        /* if (nLength > 0) { Object.freeze(vResult); } */
        return vResult;
    }

    locatorModule.JXON.prototype.parseText = function(sValue) {
        if (/^\s*$/.test(sValue)) {
            return null;
        }
        if (/^(?:true|false)$/i.test(sValue)) {
            return sValue.toLowerCase() === "true";
        }
        if (isFinite(sValue)) {
            return parseFloat(sValue);
        }
        if (isFinite(Date.parse(sValue))) {
            return new Date(sValue);
        }
        return sValue;
    };

    locatorModule.Locator = function(options) {
        if (!(this instanceof locatorModule.Locator))
            return new locatorModule.Locator(options);

        locatorModule.JXON.call(this);
        this.proxyServerID = null;
        this.proxyIndex = null;
        this.address = [];
        this.port = [];
        this.wsPort = 443;
        this.softwareVersionCheckUrl = null;
        this.version = 2;
        this.controlVersion = 1;
        this.httpStatusCode = 200; 

        return this;
    };

    locatorModule.Locator.prototype = Object.create(locatorModule.JXON.prototype);
    locatorModule.Locator.prototype.constructor = locatorModule.Locator;

    locatorModule.Locator.prototype.getProxy = function (proxyurl) {
        let _proxyurl = proxyurl;
        return this.tryToGetProxy(
            `${_proxyurl}/waveapi/proxy_locator.asp?action=getproxy&pc=wtcpJs&ver=3.0.0&requires=WTCPv2&nonce=${getNonce()}`)
            .then( result => { 
                    // Due to hardening, we got 403 forbidden response
                    // we try again with new URL /wave/_locator/proxy_locator.asp with the same parameter 
                        if( result.httpStatusCode == 403) {
                            return  this.tryToGetProxy(
                                `${_proxyurl}/wave/_locator/proxy_locator.asp?action=getproxy&pc=wtcpJs&ver=3.0.0&requires=WTCPv2&nonce=${getNonce()}`)
                                .then(result => {return result; });
                        }
                        else {
                                 return result; 
                        }
                 },
                error => { 
                        util.wtcpError("Error to get proxy", error);
                        return Promise.reject(error);
                })
                .then(result => { return result;},
                        err =>  { util.wtcpError("Exception at getProxy: ", err); return Promise.reject(err);} );

     }

    locatorModule.Locator.prototype.tryToGetProxy = function (targetUrl) {
        let locatorUrl = targetUrl;
        var _this = this;
        return new Promise(function(resolve, reject) {
                var oReq = new XMLHttpRequest();

                util.wtcpInfo("TPS Locator | getProxy url: " , locatorUrl);

                oReq.onload = function(e) {

                _this.httpStatusCode = e.currentTarget.status;
                if (e.currentTarget.status === 200) {
                    var response = _this.getJXONTree(this.responseXML);
                    if (response.serverresponse["@error"])
                        util.wtcpError("Proxy Locator returned error code " + response.serverresponse["@error"]);
                    else {
                        var proxy = response.serverresponse.proxy;
                        _this.proxyServerID = proxy["@serverid"];
                        _this.proxyIndex = proxy["@proxyindex"];
                        _this.address[0] = proxy["@address1"];
                        _this.address[1] = proxy["@address2"];
                        _this.port[0] = proxy["@port1"];
                        _this.port[1] = proxy["@port2"];
                        _this.wsPort = proxy["@wsport"];
                        _this.softwareVersionCheckUrl = proxy["@softwareversioncheckurl"];
                        _this.version = 2; // TBD: WTCP version number should be added to locator service
                        _this.controlVersion = 1; // TBD: WTCP-Ctrl OpCode version should be added to locator service
                    
                        util.wtcpInfo("TPS Locator | proxyIndex: " + _this.proxyIndex + ", ProxyServerID: " +
                            _this.proxyServerID + ", addrss1: " +
                            _this.address[0] + ", address2: " +
                            _this.address[1] + ", port1: " +
                            _this.port[0] + ", port2: " +
                            _this.port[1]);
                    }
                } 
                resolve(_this);
            };

            oReq.onerror = function(err) {
                if (typeof reject !== "undefined" && reject)
                    reject(err.statusText);
            }

            oReq.open("get", locatorUrl, true);
            try
            {
                oReq.send();   
            }
            catch(ex)
            {
                reject("exception in tryToGetProxy : "+ ex);
            }
            
        }); 
    }

    module.exports = locatorModule;

})(global.WtcpJs);